import React, { FC } from 'react';
import { IssueCaddyErrorCode } from '@bechtel/types';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { IssueCaddiesErrorProps } from './types';

const getErrorMessage = (error: IssueCaddiesErrorProps['issueCaddiesError']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case IssueCaddyErrorCode.INVALID_ROD_REQUEST_ID:
      return <Trans>Invalid Rod Request ID</Trans>;
    case IssueCaddyErrorCode.ISSUE_CADDIES_MUTATION_ERRORED:
      return <Trans>Error in Issue Caddies Mutation.</Trans>;
    case IssueCaddyErrorCode.MISSING_REQUIRED_PERMISSION:
      return <Trans>Required permissions are missing.</Trans>;
    case IssueCaddyErrorCode.SERVICE_PROXY_ERROR:
      return <Trans>Service Proxy Error.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

const IssueCaddiesErrorModal: FC<IssueCaddiesErrorProps> = ({ issueCaddiesError, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={t`Issue Caddies Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(issueCaddiesError)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};

export default IssueCaddiesErrorModal;
